import { ApolloClient, InMemoryCache } from '@apollo/client';
import { MarketType } from 'constants/markets';
import MarketHelper from 'helpers/MarketHelper';

export const cache = new InMemoryCache();

export const apolloClientServer = (market: MarketType) => new ApolloClient({
    uri: `${MarketHelper.getBackendDomain(market)}/graphql`,
    cache,
    credentials: 'include',
    defaultOptions: { query: { errorPolicy: 'all', fetchPolicy: 'no-cache' } },
});
